module.exports = __webpack_public_path__ + "static/media/cc_icon-affn.ddc27b58.svg";